module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copypage about"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/images/global/logo.svg")
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-three active",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Sign Up")])], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h2', [_vm._v("About Us")]), _vm._v(" "), _c('p', [_vm._v("The PEI exChange is the first online matching platform for all those passionate about African development.")]), _vm._v(" "), _c('p', [_vm._v("Based on user-identified criteria, including countries and regions of focus, industries, skills and experience, the PEI exChange provides personalised matches to help make your ‘Big Ideas for Africa’ a reality.")]), _vm._v(" "), _c('p', [_vm._v("Whatever it is – a charitable project, a business plan or an academic proposal – the PEI exChange makes it possible to connect with the right people, exchange ideas and knowledge and build networks to support your Big Ideas.")]), _vm._v(" "), _c('p', [_vm._v("We want to help you collaborate and innovate and stimulate. Wherever you are and whatever you need, the PEI exChange connects you to Africa.")]), _vm._v(" "), _c('p', [_vm._v("Join today and let’s drive real change for African development.")]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("The PEI exChange is delivered by the Planet Earth Institute (PEI), and charity and NGO working for the scientific independence of Africa.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22888fd5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 681
// module chunks = 1